import React from "react";
import "./Projects.css";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

function Projects() {
  return (
    <div className="projects">
      <Sidebar />

      <div className="projects-content with-sidebar">
        <div className="web-projects">
          <h2>Projects</h2>

          <div className="projects-grid">
            <article className="project-info">
              <div className="project-preview">
                <a
                  href="https://web-dev-blog-dragon.vercel.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/img/web-dev.png"
                    alt="Web Development Tutorials (Work in Progress)"
                    className="project-img"
                    loading="eager"
                  />
                </a>
              </div>

              <div className="project-copy">
                <h3>Web Development Tutorials (Work in Progress)</h3>
                <p className="project-subtitle">
                  A lightweight learning blog for exploring front-end
                  fundamentals, code snippets, and tutorials in a clean
                  developer-friendly UI.
                </p>
              </div>
            </article>

            <article className="project-info">
              <div className="project-preview">
                {/* <a
                  href="https://dragon-chat-firebase.vercel.app"
                  target="_blank"
                  rel="noopener noreferrer"
                > */}
                  <img
                    src="/img/dragon-chat.png"
                    alt="Dragon Chat"
                    className="project-img"
                    loading="eager"
                  />
                {/*</a>*/}
              </div>

              <div className="project-copy">
                <h3>Dragon Chat (Work in Progress)</h3>
                <p className="project-subtitle">
                  A real-time messaging app inspired by fast, modern chat
                  experiences, focused on fast interaction and simple user
                  flows. Built with React and Firebase. Only for Google
                  accounts.
                </p>
              </div>
            </article>

            <article className="project-info">
              <div className="project-preview">
                <a
                  href="https://parody-game.vercel.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/img/parody-game.png"
                    alt="Parody Bird"
                    className="project-img"
                    loading="eager"
                  />
                </a>
              </div>

              <div className="project-copy">
                <h3>Parody Bird</h3>
                <p className="project-subtitle">
                  A playful browser game built based off of "Flappy Bird".
                </p>
              </div>
            </article>

            <article className="project-info">
              <div className="project-preview">
                <a
                  href="https://campus-edu.vercel.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/img/campusedu.png"
                    alt="CampusEdu"
                    className="project-img"
                    loading="eager"
                    id="campusedu"
                  />
                </a>
              </div>

              <div className="project-copy">
                <h3>CampusEdu</h3>
                <p className="project-subtitle">
                  A student-focused learning platform concept that blends
                  educational discovery, streamlined navigation, and accessible
                  design that would serve as a Platform-as-a-Service (PaaS) for
                  students to access educational resources, connect with peers,
                  and enhance their learning experience. Built with React,
                  Node.js, and JSON.
                </p>
              </div>
            </article>

            <article className="project-info">
              <div className="project-preview">
                <a
                  href="https://campus-edu.vercel.app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/img/thehealthbar.png"
                    alt="The Health Bar"
                    className="project-img"
                    loading="eager"
                    id="thehealthbar"
                  />
                </a>
              </div>

              <div className="project-copy">
                <h3>The Health Bar</h3>
                <p className="project-subtitle">
                  An ERP designed for easier and more efficient inventory management, this example shows how a restaurant would record their current inventory, waste, and pending orders.
                  Built with React, MongoDB, and Node.js. Can be packaged with Docker. 
                </p>
              </div>
            </article>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Projects;
